
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionChronologyCel() {
  return (
    <>
      <div className="section section-dark section-nucleo-icons d-block d-sm-none d-none d-sm-block d-md-none d-none d-md-block d-lg-none">
        <h2 className="title gradient-title" style={{ textAlign: 'center' }}> 2018 </h2>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> Early October </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Starting to study pixel art scaling algorithms.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> October 14th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                First successful implementation of hqx algorithm in chars sprites in mugen, one of the pixel art
                scaling algorithms developed by Maxim Stepin, used in emulators such as Nestopia, FCEUX, higan, Snes9x, ZSNES and many more.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/hqx_1er.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/Test_nn.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/Test_hq3x.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> November 3th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Learned new technologies to automate part of the process and make it possible to rematerialize entire characters.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> November 4th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                First successful adaptation of the palettes to the new sprites obtained by the hqx algorithm,
                decreasing the size of the char drastically (from about 200MB per character to 40MB).
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/hqx_paletas_2do.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> November 9th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                First char with all the sprites altered with the hqx algorithm, with all the animations and functional collision boxes.
                Start of production of remastered chars using the hqx algorithm.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/hqx_completos_3er.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/hqx_completos_3er_2.jpg")}
              />
            </Col>
          </Row>
        </Container>


        <h2 className="title gradient-title" style={{ textAlign: 'center' }}> 2019 </h2>

        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> Early August </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Up to this point, 25 chars were already made with the hqx algorithm.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> 6th August </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                First comparisons of the sprites obtained from the HQX algorithm with the new sprites edited with AI and image editors by BobNostalgic.
                Starting to test with BobNostalgic.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_1er.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_2do.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> 8th August </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                First successful adaptation of the palettes used with the hqx algorithm sprites to the new sprites.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_3er.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_4to.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> 12th August </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Leaving everything advanced so far with the sprites altered with the HQX algorithm
                and starting to produce everything again but using the new sprites.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> November </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                The project was stopped and work with Bob Nostalgic was discontinued. With the new sprites, the demand for time and effort was very high, and maintaining optimal
                communication was very difficult, so we decided to go our separate ways. <br />
                Up to this point, 12 chars had been remastered with BoBNostalgic using the method implemented up to that date.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> 1th of December </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Starting to study new tools in image editors to better adapt the palettes and thus reduce work time.
                This in turn have the sprites a bit more sharpness.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_5to.jpg")}
              />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/NS_6to.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> 7th of December </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Leaving everything advanced so far, and starting to produce everything again adding what
                was learned in image editors to better adapt the palettes and reduce work time.
                From this point on, the remastered chars that will be placed in the final game begin to be produced.
              </p>
              <br />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> December 28th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Scripts developed to automatically perform part of the work, saving a lot of time and effort.
                Starting to produce new chars with remastered sprites much faster and with less work.
              </p>
              <br />
            </Col>
          </Row>
        </Container>

        <h2 className="title gradient-title" style={{ textAlign: 'center' }}> 2020 </h2>

        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> July 4th </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                All chars completed (45 in total), but not optimized.
                Up to this point, with the new tools learned in image editing and palettes, the final weight of the remastered chars was drastically reduced,
                but it was decided to continue testing ways to further optimize the new sprites.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/Pre-Optim.jpg")}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg="6" md="12" className="gradient-background-osc" style={{ textAlign: 'center' }} >
              <h5 className="title gradient-title"> August 8th  </h5>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                End of chars sprite remastering. At this point all chars were optimized, screen loads on 7200rpm HDDs took less than 3 seconds.
                The game opened faster than before and the character sprites had lost almost nothing in quality.
              </p>
              <br />
            </Col>
            <Col lg="6" md="12" className="background-claro" >
              <img
                width="100%"
                alt="..."
                className="img-rounded img-responsive"
                src={require("assets/img/Development/Post-Optim.jpg")}
              />
            </Col>
          </Row>
        </Container>
      </div>{" "}
    </>
  );
}

export default SectionChronologyCel;
